// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;

$(document).on('turbo:frame-load', function() {
  console.log('>>>>> turbo loaded');
  $('#product_type').on('change', function() {
    var product_type = $(this).val();
    window.location.href = '?product_type=' + product_type;
    //Turbo.visit('/products/?product_type=' + product_type);
    
    $('#main-body').attr('src', '/products/?product_type=' + product_type);
    //$('#main-body').reload();
  });
  
  if( $('#main-body.section-products-edit').html() ) {
    change_product_fields( $('#product_kind').val() );
  }
  
  
  $('#product_width, #product_height, #product_paper_id').on('change', function() {
    var paper_id = $('#product_paper_id').val()
    var width = $('#product_width').val();
    var height = $('#product_height').val();
  
    if( isNaN(parseFloat(width)) ) width = 1;
    if( isNaN(parseFloat(height)) ) height = 1;
  
    $.get("/products/calculate_ups", {paper_id: paper_id, width: width, height: height} ).done(function(data) {
      $('#product_ups').val(data);
    });
  
  });
});

$(document).on('change', '#product_kind', function() {
  console.log('>>>> product type menu changed: ' + $('#product_kind').val());
  change_product_fields( $('#product_kind').val() );
}); 

function change_product_fields(type) {
  switch( type ) {
    case 'Paper':
      $('.product-type-group').hide();
      $('.paper-elements').show();
      break;
    case 'Garment':
    case 'Screen':
      $('.product-type-group').hide();
      $('.garment-elements').show()
      break;
    default: 
      $('.product-type-group').hide();
      $('#product_design_fee').val('0');
  }
  /*
  if( type == 'Paper' ) {
    $('.product-type-group').hide();
    $('.paper-elements').show();
  } else if( type == 'Garment' ) {
    $('.product-type-group').hide();
    $('.garment-elements').show()
  } else if( type == 'Screen' ) {
    $('.product-type-group').hide(); 
    $('.screen-elements').show();
  } else {
    $('.product-type-group').hide();
  }
  */
}

